// JavaScript Document

// custom skin for Tipped JS for StevensFarm.com

jQuery.extend(Tipped.Skins, {
  'stevensFarm' : {
	hook: { target:  'bottommiddle' ,tooltip: 'topmiddle' },
	border: { size: 3, color: '#959fa9' },
	maxWidth: 500,
	background: {
	color: [
        { position: 0, color: '#fefefe' },
        { position: 1, color: '#f7f7f7' }
      ]
    },
	radius: { size: 3, position: 'border' },
	shadow: { blur: 2, opacity: .15 },
	closeButtonSkin: 'light'
  },
    'stevensFarm_click' : {
	//inline: true,
	hook: { target:  'topmiddle' ,tooltip: 'bottommiddle' },
	showOn: 'click',
	hideOn: 'click',
	hideOnClickOutside: true,
	border: { size: 3, color: '#959fa9' },
	maxWidth: 500,
	background: {
	color: [
        { position: 0, color: '#fefefe' },
        { position: 1, color: '#f7f7f7' }
      ]
    },
	radius: { size: 3, position: 'border' },
	shadow: { blur: 2, opacity: .15 },
	closeButton: true,
	closeButtonSkin: 'light'
  }

});